module.exports = __webpack_public_path__ + "img/mg-msum-logo.9c0fc754.svg";